import React from "react";
import Footer3 from "../Footer3";
import "./Footer2.css";

function Footer2(props) {
  const { footer3Props } = props;

  return (
    <div className="footer-3">
      <Footer3 footerProps={footer3Props.footerProps} />
    </div>
  );
}

export default Footer2;
